export function fieldStateClasses(error: string | undefined, readOnly: boolean): string {
  if (error) {
    return 'border-[var(--color-error)] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[var(--color-error-600)]'
  }
  if (readOnly) {
    return 'border-[var(--color-border)] focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-[var(--color-primary-500)]'
  }
  return 'border-[var(--color-field-border)] hover:not-disabled:border-[var(--color-field-hover)] focus:outline-none focus:border-[var(--color-primary-400)] focus:shadow-[var(--focus-ring)]'
}
